<template>
  <div class="container">
    <div class="pageTitle">
      1、结算之后，结算的金额将会从相应经销商的账户余额中扣除，请通过线下打款完成返利结算
      <br />2、列表只显示获得返利的经销商
    </div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="直属经销商" name="1">
        <el-tabs v-model="active" type="card" @tab-click="handleClick">
          <el-tab-pane label="结算管理" name="first">
            <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
              <el-form-item label="到账时间:" style="text-align: center">
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="开始时间"
                    v-model="form.start_time"
                    style="width: 100%;"
                    clearable
                  ></el-date-picker>
                </el-col>
                <el-col :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="结束时间"
                    v-model="form.end_time"
                    style="width: 100%;"
                    clearable
                  ></el-date-picker>
                </el-col>
              </el-form-item>
              <el-form-item label="经销商:">
                <el-col :span="20" style="margin-right:20px;">
                  <el-input v-model="form.production_batch" clearable></el-input>
                </el-col>
                <el-col :span="2">
                  <el-button @click="selectDealerDialog=!selectDealerDialog">选择</el-button>
                </el-col>
              </el-form-item>

              <el-form-item label="订单号:">
                <el-input v-model="form.production_batch" clearable></el-input>
              </el-form-item>
              <!--  -->

              <!--  -->
              <el-form-item>
                <el-button type="primary" @click="onSearch()" class="mr-10">搜索</el-button>
                <el-button @click="exportData()">导出</el-button>
              </el-form-item>
            </el-form>
            <!--表格-->
            <el-table
              ref="multipleTable"
              :data="tableData1"
              v-loading="loading"
              border
              stripe
              style="width: 100%;margin: 20px"
            >
              <el-table-column prop label="经销商编号" fixed></el-table-column>
              <el-table-column prop label="经销商名称" show-overflow-tooltip></el-table-column>
              <el-table-column prop label="经销商级别" show-overflow-tooltip></el-table-column>
              <el-table-column prop label="余额变动" show-overflow-tooltip></el-table-column>
              <el-table-column prop label="类型" show-overflow-tooltip></el-table-column>
              <el-table-column prop label="时间" show-overflow-tooltip></el-table-column>
              <el-table-column prop label="账户余额" show-overflow-tooltip></el-table-column>

              <el-table-column prop label="操作" width="180" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="edit(scope.$index)">查看详情</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              style="margin: 20px 0"
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
              :current-page="pageNo1"
              :page-sizes="[20, 50, 100, 200]"
              :page-size="pageSize1"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalSize1"
            ></el-pagination>
          </el-tab-pane>
          <el-tab-pane label="结算记录" name="second">
            <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
              <el-form-item label="到账时间:" style="text-align: center">
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="开始时间"
                    v-model="form.start_time"
                    style="width: 100%;"
                    clearable
                  ></el-date-picker>
                </el-col>
                <el-col :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="结束时间"
                    v-model="form.end_time"
                    style="width: 100%;"
                    clearable
                  ></el-date-picker>
                </el-col>
              </el-form-item>
              <el-form-item label="经销商:">
                <el-col :span="20" style="margin-right:20px;">
                  <el-input v-model="form.production_batch" clearable></el-input>
                </el-col>
                <el-col :span="2">
                  <el-button @click="selectDealerDialog=!selectDealerDialog">选择</el-button>
                </el-col>
              </el-form-item>

              <el-form-item label="订单号:">
                <el-input v-model="form.production_batch" clearable></el-input>
              </el-form-item>
              <!--  -->

              <!--  -->
              <el-form-item>
                <el-button type="primary" @click="onSearch()" class="mr-10">搜索</el-button>
                <el-button @click="exportData()">导出</el-button>
              </el-form-item>
            </el-form>
            <!--表格-->
            <el-table
              ref="multipleTable"
              :data="tableData1"
              v-loading="loading"
              border
              stripe
              style="width: 100%;margin: 20px"
            >
              <el-table-column prop label="经销商编号" fixed></el-table-column>
              <el-table-column prop label="经销商名称" show-overflow-tooltip></el-table-column>
              <el-table-column prop label="经销商级别" show-overflow-tooltip></el-table-column>
              <el-table-column prop label="余额变动" show-overflow-tooltip></el-table-column>
              <el-table-column prop label="类型" show-overflow-tooltip></el-table-column>
              <el-table-column prop label="时间" show-overflow-tooltip></el-table-column>
              <el-table-column prop label="账户余额" show-overflow-tooltip></el-table-column>

              <el-table-column prop label="操作" width="180" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="edit(scope.$index)">查看详情</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              style="margin: 20px 0"
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
              :current-page="pageNo1"
              :page-sizes="[20, 50, 100, 200]"
              :page-size="pageSize1"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalSize1"
            ></el-pagination>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
      <el-tab-pane label="非直属经销商" name="second">
       <el-tabs v-model="active1" type="card" @tab-click="handleClick">
          <el-tab-pane label="结算管理" name="first">
            <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
              <el-form-item label="到账时间:" style="text-align: center">
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="开始时间"
                    v-model="form.start_time"
                    style="width: 100%;"
                    clearable
                  ></el-date-picker>
                </el-col>
                <el-col :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="结束时间"
                    v-model="form.end_time"
                    style="width: 100%;"
                    clearable
                  ></el-date-picker>
                </el-col>
              </el-form-item>
              <el-form-item label="经销商:">
                <el-col :span="20" style="margin-right:20px;">
                  <el-input v-model="form.production_batch" clearable></el-input>
                </el-col>
                <el-col :span="2">
                  <el-button @click="selectDealerDialog=!selectDealerDialog">选择</el-button>
                </el-col>
              </el-form-item>

              <el-form-item label="订单号:">
                <el-input v-model="form.production_batch" clearable></el-input>
              </el-form-item>
              <!--  -->

              <!--  -->
              <el-form-item>
                <el-button type="primary" @click="onSearch()" class="mr-10">搜索</el-button>
                <el-button @click="exportData()">导出</el-button>
              </el-form-item>
            </el-form>
            <!--表格-->
            <el-table
              ref="multipleTable"
              :data="tableData1"
              v-loading="loading"
              border
              stripe
              style="width: 100%;margin: 20px"
            >
              <el-table-column prop label="经销商编号" fixed></el-table-column>
              <el-table-column prop label="经销商名称" show-overflow-tooltip></el-table-column>
              <el-table-column prop label="经销商级别" show-overflow-tooltip></el-table-column>
              <el-table-column prop label="余额变动" show-overflow-tooltip></el-table-column>
              <el-table-column prop label="类型" show-overflow-tooltip></el-table-column>
              <el-table-column prop label="时间" show-overflow-tooltip></el-table-column>
              <el-table-column prop label="账户余额" show-overflow-tooltip></el-table-column>

              <el-table-column prop label="操作" width="180" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="edit(scope.$index)">查看详情</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              style="margin: 20px 0"
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
              :current-page="pageNo1"
              :page-sizes="[20, 50, 100, 200]"
              :page-size="pageSize1"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalSize1"
            ></el-pagination>
          </el-tab-pane>
          <el-tab-pane label="结算记录" name="second">
            <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
              <el-form-item label="到账时间:" style="text-align: center">
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="开始时间"
                    v-model="form.start_time"
                    style="width: 100%;"
                    clearable
                  ></el-date-picker>
                </el-col>
                <el-col :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="结束时间"
                    v-model="form.end_time"
                    style="width: 100%;"
                    clearable
                  ></el-date-picker>
                </el-col>
              </el-form-item>
              <el-form-item label="经销商:">
                <el-col :span="20" style="margin-right:20px;">
                  <el-input v-model="form.production_batch" clearable></el-input>
                </el-col>
                <el-col :span="2">
                  <el-button @click="selectDealerDialog=!selectDealerDialog">选择</el-button>
                </el-col>
              </el-form-item>

              <el-form-item label="订单号:">
                <el-input v-model="form.production_batch" clearable></el-input>
              </el-form-item>
              <!--  -->

              <!--  -->
              <el-form-item>
                <el-button type="primary" @click="onSearch()" class="mr-10">搜索</el-button>
                <el-button @click="exportData()">导出</el-button>
              </el-form-item>
            </el-form>
            <!--表格-->
            <el-table
              ref="multipleTable"
              :data="tableData1"
              v-loading="loading"
              border
              stripe
              style="width: 100%;margin: 20px"
            >
              <el-table-column prop label="经销商编号" fixed></el-table-column>
              <el-table-column prop label="经销商名称" show-overflow-tooltip></el-table-column>
              <el-table-column prop label="经销商级别" show-overflow-tooltip></el-table-column>
              <el-table-column prop label="余额变动" show-overflow-tooltip></el-table-column>
              <el-table-column prop label="类型" show-overflow-tooltip></el-table-column>
              <el-table-column prop label="时间" show-overflow-tooltip></el-table-column>
              <el-table-column prop label="账户余额" show-overflow-tooltip></el-table-column>

              <el-table-column prop label="操作" width="180" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="edit(scope.$index)">查看详情</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              style="margin: 20px 0"
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
              :current-page="pageNo1"
              :page-sizes="[20, 50, 100, 200]"
              :page-size="pageSize1"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalSize1"
            ></el-pagination>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>

    <selectDealer
      v-if="selectDealerDialog"
      v-on:handleClose="selectDealerDialog = false"
      @pushData="getSelectinfo"
    ></selectDealer>
    <!--批量导入-->
    <importData
      v-if="importDataDialog"
      v-on:handleClose="importDataDialog = false"
      @refresh="onSearch"
    ></importData>
    <!--物流码明细-->
    <deliverCodeDialog
      v-if="deliverCodeDialog"
      v-on:handleClose="deliverCodeDialog = false"
      :stock_out_sn="stock_out_sn"
    ></deliverCodeDialog>
  </div>
</template>

<script>
import selectDealer from "@/components/logistics/common/selectDealer.vue";
export default {
  name: "deliver-manage",
  data() {
    return {
      activeName: "1",
      active: "first",
      active1: "first",

      loading: false,
      selectDealerDialog: false,
      importDataDialog: false,
      deliverCodeDialog: false,
      form: {
        start_time: "",
        end_time: "",
        production_batch: "",
        stock_out_sn: "",
        product_sn: "",
        product_name: "",
        warehouse_sn: "",
        status: "",
        to_sn: "",
        to_type: "",
        isgift: ""
      },
      stockArray: [], //仓库
      tableData: [],
      //分页
      pageNo: 1,
      pageSize: 20,
      totalSize: 0,
      stock_out_sn: "", //传给物流明细
      showLink: false //'登陆地址弹窗'
    };
  },
  methods: {
    getLastMonth() {
      var now = new Date();
      var year = now.getFullYear(); //getYear()+1900=getFullYear()
      var month = now.getMonth() + 1; //0-11表示1-12月
      var day = now.getDate();
      var dateObj = {};
      if (parseInt(month) < 10) {
        month = "0" + month;
      }
      if (parseInt(day) < 10) {
        day = "0" + day;
      }

      dateObj.now = year + "-" + month + "-" + day;

      if (parseInt(month) == 1) {
        //如果是1月份，则取上一年的12月份
        dateObj.last = parseInt(year) - 1 + "-12-" + day;
        return dateObj;
      }

      var preSize = new Date(year, parseInt(month) - 1, 0).getDate(); //上月总天数
      if (preSize < parseInt(day)) {
        //上月总天数<本月日期，比如3月的30日，在2月中没有30
        dateObj.last = year + "-" + month + "-01";
        return dateObj;
      }

      if (parseInt(month) <= 10) {
        dateObj.last = year + "-0" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      } else {
        dateObj.last = year + "-" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      }
    },
    //获取仓库
    getStock() {
      this.$get("logistics", "/warehouses.all", {
        lang: ""
      })
        .then(res => {
          this.stockArray = res.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //获取选择经销商门店
    getSelectinfo(val) {
      if (val.dealer_sn) {
        this.form.to_sn = val.dealer_sn;
        this.form.to_type = 2;
      } else {
        this.form.to_sn = val.shop_sn;
        this.form.to_type = 3;
      }
    },
    //请求列表数据
    onSearch() {
      let beginstr = "",
        endstr = "";
      if (this.form.start_time) {
        beginstr = this.moment(this.form.start_time).format("YYYY-MM-DD");
      }
      if (this.form.end_time) {
        endstr = this.moment(this.form.end_time).format("YYYY-MM-DD");
      }
      this.loading = true;
      this.$get("logistics", "/outwarehouses", {
        lang: "",
        start_time: beginstr,
        end_time: endstr,
        product_sn: this.form.product_sn,
        stock_out_sn: this.form.stock_out_sn,
        production_batch: this.form.production_batch,
        product_name: this.form.product_name,
        warehouse_sn: this.form.warehouse_sn,
        to_type: this.form.to_type,
        to_sn: this.form.to_sn,
        status: this.form.status,
        isgift: this.form.isgift,
        per_page: this.pageSize,
        page: this.pageNo
      })
        .then(res => {
          this.loading = false;
          this.tableData = res.data;
          this.totalSize = res.meta.total;
        })
        .catch(function(error) {
          this.loading = false;
          console.log(error);
        });
    },
    //添加发货
    addDeliver() {
      this.$router.push({
        name: "addWareOrder"
      });
    },
    //批量导入
    importData() {
      this.importDataDialog = true;
    },
    //选择经销商/门店
    selectType() {
      this.selectDealerDialog = true;
    },
    //导出
    exportData() {
      let beginstr = "",
        endstr = "";
      if (this.form.start_time) {
        beginstr = this.moment(this.form.start_time).format("YYYY-MM-DD");
      }
      if (this.form.end_time) {
        endstr = this.moment(this.form.end_time).format("YYYY-MM-DD");
      }
      let url = "",
        access_tokens = localStorage.getItem("access_tokens");
 

      window.open(
        this.$Base_Export+
          "/outwarehouses.export?is_export=1&start_time=" +
          beginstr +
          "&end_time=" +
          endstr +
          "&product_sn=" +
          this.form.product_sn +
          "&stock_out_sn=" +
          this.form.stock_out_sn +
          "&production_batch=" +
          this.form.production_batch +
          "&product_name=" +
          this.form.product_name +
          "&lang=" +
          "" +
          "&warehouse_sn=" +
          this.form.warehouse_sn +
          "&to_type=" +
          this.form.to_type +
          "&to_sn=" +
          this.form.to_sn +
          "&status=" +
          this.form.status +
          "&isgift=" +
          this.form.isgift +
          "&signature=" +
          this.$md5(access_tokens)
      );
    },
    //发货标签码明细
    deliverDetail(row) {
      this.stock_out_sn = row.stock_out_sn;
      this.deliverCodeDialog = true;
    },
    //打印
    print(item) {
      this.$router.push({
        name: "printDeliver",
        query: {
          stock_out_sn: item.stock_out_sn
        }
      });
    },
    //编辑
    edit(item) {
      this.$router.push({
        name: "addDeliver",
        query: {
          stock_out_sn: item.stock_out_sn
        }
      });
    },
    //删除
    del(item) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let url = "/outwarehouses/" + item.stock_out_sn;
          this.$delete("logistics", url, {})
            .then(res => {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.onSearch();
            })
            .catch(error => {
              this.$message({
                type: "error",
                message: error.message
              });
            });
        })
        .catch(error => {
          this.$message({
            type: "error",
            message: error.message
          });
        });
    },
    /*分页*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.onSearch();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.onSearch();
    },
    // 关闭 登陆地址弹窗
    closeLink() {
      this.showLink = !this.showLink;
    }
  },
  created() {
    this.form.start_time = this.getLastMonth().last;
    this.form.end_time = this.getLastMonth().now;
    this.getStock();
    this.onSearch();
  },
  components: {
    // , importData, deliverCodeDialog
    selectDealer
  }
};
</script>
<style lang="scss" scoped>
.container .pageTitle {
  height: auto;
  margin-bottom: 10px;
}
</style>